module.exports = __webpack_public_path__ + "img/VW-idbuzz.702566ee.jpg";